import { noop } from 'lodash';
import React, { createContext, PropsWithChildren, useCallback, useContext, useEffect, useState } from 'react';
import { gql, useQuery } from 'urql';
import { DeepPartialGraph } from '../types';
import { HacpackQuery } from '../types/graph';

type PackagingsQueryData = DeepPartialGraph<HacpackQuery>

const packagingsQuery = gql<PackagingsQueryData>`
    query {
        packagings {
            id
            code
            description
            fullName
        }
        extraPmisPackagings {
            id
            name
        }
    }
`;

export type PackagingsContextObject = {
    data?: DeepPartialGraph<HacpackQuery> | null,
    load: () => void
};

const context = createContext<PackagingsContextObject>({
    data: null,
    load: noop
});

type PackagingsProps = PropsWithChildren<{
    lazy?: boolean
}>;

type UsePackagingsProps = {
    lazy: boolean
};

export const usePackagings = (props:UsePackagingsProps|undefined=undefined) => {
    const { data, load } = useContext(context);
    const lazy = props?.lazy??false;

    useEffect(() => {
        if (data === undefined && lazy !== true) {
            load();
        }
    }, [data, lazy]);

    return {data,load};
}

export const PackagingsContext = ({ children, lazy = false }: PackagingsProps) => {
    const [pause, setPause] = useState<boolean>(lazy)

    const [result] = useQuery<PackagingsQueryData>({
        query: packagingsQuery,
        pause
    });

    const { data, fetching, error } = result;

    if (error !== undefined) {
        console.error(error);
    }

    const load = useCallback(() => {
        setPause(false);
    }, [setPause]);

    return <context.Provider value={{ data, load }}>{children}</context.Provider>;
};
